module.exports = __webpack_public_path__ + "img/party_face_emoji.14bbcdc.png";